<script lang="ts">
    import { Dialog, Dot, H3 } from "attractions";
    import Purchase from "../../Models/Purchase";
    import { LATEST_PURCHASE_WITH_PAYMENT_ACTION } from "../../Stores/Purchase";

    export let paymentCheckboxEvent;
    export let purchasePaymentConfirmationDialogMode;
    export let purchaseEvent;
    export let items;

    async function handleMarkAsPaid() {
        const paymentStatus = paymentCheckboxEvent.detail.checked;
        const res = await Purchase.changePaymentStatus(purchaseEvent._id, paymentStatus);
        items[items.indexOf(purchaseEvent)].paid = paymentStatus;
        LATEST_PURCHASE_WITH_PAYMENT_ACTION.set(new Date().getTime().toString());
        purchasePaymentConfirmationDialogMode = false;
    }

    function cancelAction() {
        purchasePaymentConfirmationDialogMode = false;
    }
</script>

<Dialog class="confirmationDialog" title="Potwierdzenie">
    <H3 style="font-size: 1rem;">Czy na pewno chcesz zmienić status zakupu?</H3>
    <section class="actions">
        <small class="actionButton" on:click={handleMarkAsPaid}><Dot small style="margin-right: .25rem" /> Tak, jest w porządku</small>
        <small class="actionButton" on:click={cancelAction}><Dot danger small style="margin-right: .25rem" /> Anuluj</small>
    </section>
</Dialog>

<style lang="scss">
    .actions {
        display: flex;

        .actionButton {
            margin: {
                left: .5rem;
                top: .5rem;
            }
            display: flex;
            align-items: center;
            font-size: .75rem;
            cursor: pointer;

            &:first-of-type {
                margin-left: 0;
            }
        }
    }
</style>